import { ResponsePostAuthLogin } from "./login";

export const RouteGetAuthRenewToken = "/auth/renew-token";

export type ResponseGetAuthRenewToken = ResponsePostAuthLogin;
